import React from 'react'

const PreNav = () => {
  return (
    <div className="py-3 bg-dark bg-pattern @@classList">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="text-center text-white">
              <span className="heading-xxs letter-spacing-xl">
                ⚡️ Happy Holiday Deals on Everything ⚡️
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PreNav